import { useAtomValue } from 'jotai'
import React from 'react'

import { Box } from '~/components/elements/Box'
import { VStack } from '~/components/elements/VStack'
import { exists } from '~/utils'

import { segmentDisplayTypeAtom, tabulationQueryDataAtom } from '../atoms'

import { FiveSegmentsTable } from './FiveSegmentsTable'
import { NineSegmentsTable } from './NineSegmentsTable'

export const CustomerAnalysisTable = () => {
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const segmentDisplayType = useAtomValue(segmentDisplayTypeAtom)

  return (
    <Box>
      {exists(tabulationQueryData) && (
        <VStack align="start" spacing={8}>
          {segmentDisplayType !== 'nineSegs' && <FiveSegmentsTable />}

          {segmentDisplayType !== 'fiveSegs' && <NineSegmentsTable />}
        </VStack>
      )}
    </Box>
  )
}
